export function displayHandicapPoints(points) {
    return parseFloat(points) > 0 ? `+${points}` : points;
}
//# sourceMappingURL=displayHandicapPoints.js.map